import uuidV4 from 'uuid/v4';
import * as types from './constants';


export const removeNotification = id => ({
  type: types.NOTIFICATION_REMOVE,
  id
});

export const addNotification = (notification, timeout) => {
  const uuid = uuidV4();
  const timeout_ms = timeout || 2500;
  return (dispatch) => {
    dispatch({
      type: types.NOTIFICATION_ADD,
      entity: Object.assign({}, notification, { id: uuid })
    });
    setTimeout(() => {
      dispatch(removeNotification(uuid));
    }, timeout_ms);
  };
};
